import { createSelector } from 'reselect'
import { listFeatureStateSelector } from './listFeatureStateSelector'

export const isNeedToFetchListSelector = createSelector(
  listFeatureStateSelector,
  state => state.pages.length < state.currentPage * state.size && state.pages.length < state.total
)

export default isNeedToFetchListSelector
